import moment from 'moment';
import { DRIP_POSTFIX_URL, WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';

const getBasicAutomationStats = ({webId, start_date, end_date}) => ky.post(`${WEBSITE_URL}${webId}/basic-automation/`, {
    json: {
        start_date: moment.utc(start_date).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        end_date: moment.utc(end_date).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateBasicAutomation = (webId, payload) => ky.patch(`${WEBSITE_URL}${webId}/basic-automation/`, {
    json: payload,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getWelcomeNotificationDetails = (webKey) => ky.get(`${WEBSITE_URL}${webKey}/welcome_notification/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json()


const updateWelcomeNotifications = (webId, welcomePayload) => ky.patch(`${WEBSITE_URL}${webId}/welcome-notification/`, {
    body: welcomePayload,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateDripNotifications = (webId, dripPayload) => ky.patch(`${WEBSITE_URL}${webId}/basic-automation/`, {
    json: dripPayload,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getDrips = (webId) => ky.get(`${WEBSITE_URL}${webId}${DRIP_POSTFIX_URL}`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const addDrip = (webId, formData) => ky.post(`${WEBSITE_URL}${webId}${DRIP_POSTFIX_URL}`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateDrip = (webId, dripId, formData) => ky.patch(`${WEBSITE_URL}${webId}${DRIP_POSTFIX_URL}${dripId}/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const disableDrip = (webId, dripId, is_active) => ky.patch(`${WEBSITE_URL}${webId}${DRIP_POSTFIX_URL}${dripId}/`, {
    json: {is_active},
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const deleteDrip = (webId, dripId) => ky.delete(`${WEBSITE_URL}${webId}${DRIP_POSTFIX_URL}${dripId}/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getRssFeeds = (webId) => ky.get(`${WEBSITE_URL}${webId}/rss-feeds/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const addRssFeeds = (webId, rssData) => ky.post(`${WEBSITE_URL}${webId}/rss-feeds/`, {
    json: rssData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateRssFeed = (webId, rssData, rssId) => ky.patch(`${WEBSITE_URL}${webId}/rss-feeds/${rssId}`, {
    json: rssData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const deleteRssFeed = (webId, rssId) => ky.delete(`${WEBSITE_URL}${webId}/rss-feeds/${rssId}`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export {
    getWelcomeNotificationDetails,
    getBasicAutomationStats,
    getDrips,
    addDrip,
    updateWelcomeNotifications,
    updateDrip,
    disableDrip,
    updateDripNotifications,
    deleteDrip,
    updateBasicAutomation,
    getRssFeeds,
    addRssFeeds,
    updateRssFeed,
    deleteRssFeed
};